type Props = {
  data: any;
};

const Gad7Result = ({ data }: Props) => {
  // console.log(data);
  return (
    <div className="py-4">
      <div className="w-full flex items-center justify-between">
        <strong className="py-4 block">{data.name}</strong>
        <div className="bg-blue-100 py-1 px-2 rounded-lg font-bold">
          {data?.result?.grade ?? 0} - {data?.result?.title}
        </div>
      </div>
      <div className="">
        <p className="">{data?.result?.description?.id}</p>
      </div>
    </div>
  );
};

export default Gad7Result;
